module.exports = __webpack_public_path__ + "static/img/pingtaibg3.786c2446.png";